webpackJsonp([1],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuexfire__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuexfire__);




// import venues from './modules/venues'

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */].Store({
  state: {
    user: null, // Will be bound as an object
    venues: null
  },
  actions: {},
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    UPDATE_USER: function UPDATE_USER(state, user) {
      state.user = user;
    },
    UPDATE_VENUES: function UPDATE_VENUES(state, venues) {
      state.venues = venues;
    }
  }, __WEBPACK_IMPORTED_MODULE_3_vuexfire__["firebaseMutations"]),
  getters: {
    venues: function venues(state) {
      return state.venues;
    },
    user: function user(state) {
      return state.user;
    }
  },
  // modules: {
  //   venues
  // },
  strict: false // (can not use strict mode with vuexfir) debug
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(656),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a60bd04",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Hello__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Venue_View__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Venue_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Venue_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Venue_Edit__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Venue_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Venue_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Login__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Profile__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Profile__);







// import VenueAdd from '@/components/Venue/Add'


// import Auth from '@/components/Auth'
// import AuthSuccess from '@/components/AuthSuccess'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Hello___default.a
  }, {
    path: '/venue/:key',
    name: 'VenueView',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Venue_View___default.a
  }, {
    path: '/add-venue',
    name: 'VenueAdd',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Venue_Edit___default.a
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Login___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user) {
        next('/');
      } else {
        next();
      }
    }
  }, {
    path: '/logout',
    name: 'Logout',
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user) {
        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signOut();
        next('/');
      } else {
        next('/login');
      }
    }
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Profile___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '*',
    redirect: '/'
  }]
});

/**
 * Check if a route requires authentication.
 * This is a global before hook for all routes,
 * checks if there are `meta: { requiresAuth: true }`
 * in all matched routes and sub routes.
 * If yes, redirect to `/login` and add original path to the query.
 */
router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(666),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_weakmap__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_weakmap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_weakmap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__initFirebase__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuefire__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_instantsearch__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_resource__ = __webpack_require__(279);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// polyfills

 // for vuexfire, using (imports-loader)







// bootstrap

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_bootstrap_vue__["a" /* default */]);



// firebase


__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vuefire___default.a);

// algolia

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_instantsearch__["a" /* default */]);

// resource

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

// Sync the router with the vuex store. This registers `store.state.route`
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ADDRESS_COMPONENTS = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'county',
    country: 'long_name',
    postal_code: 'short_name'
};

var CITIES_TYPE = ['locality', 'administrative_area_level_3'];
var REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country', 'administrative_area_level_1', 'administrative_area_level_2'];

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VueGoogleAutocomplete',

    props: {
        id: {
            type: String,
            required: true
        },

        classname: String,

        placeholder: {
            type: String,
            default: 'Start typing'
        },

        types: {
            type: String,
            default: 'address'
        },

        country: {
            type: [String, Array],
            default: null
        },

        enableGeolocation: {
            type: Boolean,
            default: false
        },

        geolocationOptions: {
            type: Object,
            default: null
        }
    },

    data: function data() {
        return {
            /**
             * The Autocomplete object.
             *
             * @type {Autocomplete}
             * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
             */
            autocomplete: null,

            /**
             * Autocomplete input text
             * @type {String}
             */
            autocompleteText: '',

            geolocation: {
                /**
                 * Google Geocoder Objet
                 * @type {Geocoder}
                 * @link https://developers.google.com/maps/documentation/javascript/reference#Geocoder
                 */
                geocoder: null,

                /**
                 * Filled after geolocate result
                 * @type {Coordinates}
                 * @link https://developer.mozilla.org/en-US/docs/Web/API/Coordinates
                 */
                loc: null,

                /**
                 * Filled after geolocate result
                 * @type {Position}
                 * @link https://developer.mozilla.org/en-US/docs/Web/API/Position
                 */
                position: null
            }
        };
    },


    watch: {
        autocompleteText: function autocompleteText(newVal, oldVal) {
            this.$emit('inputChange', { newVal: newVal, oldVal: oldVal }, this.id);
        },
        country: function country(newVal, oldVal) {
            this.autocomplete.setComponentRestrictions({
                country: this.country === null ? [] : this.country
            });
        }
    },

    mounted: function mounted() {
        var options = {};

        if (this.types) {
            options.types = [this.types];
        }

        if (this.country) {
            options.componentRestrictions = {
                country: this.country
            };
        }

        this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.id), options);

        this.autocomplete.addListener('place_changed', this.onPlaceChanged);
    },

    methods: {
        /**
         * When a place changed
         */
        onPlaceChanged: function onPlaceChanged() {
            var place = this.autocomplete.getPlace();

            if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                this.$emit('no-results-found', place, this.id);
                return;
            }

            if (place.address_components !== undefined) {
                // return returnData object and PlaceResult object
                this.$emit('placechanged', this.formatResult(place), place, this.id);

                // update autocompleteText then emit change event
                this.autocompleteText = document.getElementById(this.id).value;
                this.onChange();
            }
        },


        /**
         * When the input gets focus
         */
        onFocus: function onFocus() {
            this.biasAutocompleteLocation();
            this.$emit('focus');
        },


        /**
         * When the input loses focus
         */
        onBlur: function onBlur() {
            this.$emit('blur');
        },


        /**
         * When the input got changed
         */
        onChange: function onChange() {
            this.$emit('change', this.autocompleteText);
        },


        /**
         * When a key gets pressed
         * @param  {Event} event A keypress event
         */
        onKeyPress: function onKeyPress(event) {
            this.$emit('keypress', event);
        },


        /**
         * When a keyup occurs
         * @param  {Event} event A keyup event
         */
        onKeyUp: function onKeyUp(event) {
            this.$emit('keyup', event);
        },


        /**
         * Clear the input
         */
        clear: function clear() {
            this.autocompleteText = '';
        },


        /**
         * Focus the input
         */
        focus: function focus() {
            this.$refs.autocomplete.focus();
        },


        /**
         * Blur the input
         */
        blur: function blur() {
            this.$refs.autocomplete.blur();
        },


        /**
         * Update the value of the input
         * @param  {String} value
         */
        update: function update(value) {
            this.autocompleteText = value;
        },


        /**
         * Update the coordinates of the input
         * @param  {Coordinates} value
         */
        updateCoordinates: function updateCoordinates(value) {
            var _this = this;

            if (!value && !(value.lat || value.lng)) return;
            if (!this.geolocation.geocoder) this.geolocation.geocoder = new google.maps.Geocoder();
            this.geolocation.geocoder.geocode({ 'location': value }, function (results, status) {
                if (status === 'OK') {
                    results = _this.filterGeocodeResultTypes(results);
                    if (results[0]) {
                        _this.$emit('placechanged', _this.formatResult(results[0]), results[0], _this.id);
                        _this.update(results[0].formatted_address);
                    } else {
                        _this.$emit('error', 'no result for provided coordinates');
                    }
                } else {
                    _this.$emit('error', 'error getting address from coords');
                }
            });
        },


        /**
         * Update location based on navigator geolocation
         */
        geolocate: function geolocate() {
            var _this2 = this;

            this.updateGeolocation(function (geolocation, position) {
                _this2.updateCoordinates(geolocation);
            });
        },


        /**
         * Update internal location from navigator geolocation
         * @param  {Function} (geolocation, position)
         */
        updateGeolocation: function updateGeolocation() {
            var _this3 = this;

            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (navigator.geolocation) {
                var options = {};
                if (this.geolocationOptions) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(options, this.geolocationOptions);
                navigator.geolocation.getCurrentPosition(function (position) {
                    var geolocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    _this3.geolocation.loc = geolocation;
                    _this3.geolocation.position = position;

                    if (callback) callback(geolocation, position);
                }, function (err) {
                    _this3.$emit('error', 'Cannot get Coordinates from navigator', err);
                }, options);
            }
        },


        // Bias the autocomplete object to the user's geographical location,
        // as supplied by the browser's 'navigator.geolocation' object.
        biasAutocompleteLocation: function biasAutocompleteLocation() {
            var _this4 = this;

            if (this.enableGeolocation) {
                this.updateGeolocation(function (geolocation, position) {
                    var circle = new google.maps.Circle({
                        center: geolocation,
                        radius: position.coords.accuracy
                    });
                    _this4.autocomplete.setBounds(circle.getBounds());
                });
            }
        },


        /**
         * Format result from Geo google APIs
         * @param place
         * @returns {{formatted output}}
         */
        formatResult: function formatResult(place) {
            var returnData = {};
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];

                if (ADDRESS_COMPONENTS[addressType]) {
                    var val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                    returnData[addressType] = val;
                }
            }

            returnData['latitude'] = place.geometry.location.lat();
            returnData['longitude'] = place.geometry.location.lng();
            return returnData;
        },


        /**
         * Extract configured types out of raw result as
         * Geocode API does not allow to do it
         * @param results
         * @returns {GeocoderResult}
         * @link https://developers.google.com/maps/documentation/javascript/reference#GeocoderResult
         */
        filterGeocodeResultTypes: function filterGeocodeResultTypes(results) {
            if (!results || !this.types) return results;
            var output = [];
            var types = [this.types];
            if (types.includes('(cities)')) types = types.concat(CITIES_TYPE);
            if (types.includes('(regions)')) types = types.concat(REGIONS_TYPE);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var r = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(r.types), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var t = _step2.value;

                            if (types.includes(t)) {
                                output.push(r);
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return output;
        }
    }
});

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainMenu__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MainMenu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__components_MainMenu___default.a },
  data: function data() {
    return {
      currentYear: new Date().getFullYear()
    };
  },

  methods: {
    transitionName: function transitionName() {
      return this.$route.fullPath === '/' ? 'slide-right' : 'slide-left';
    }
  }
});

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_instantsearch__ = __webpack_require__(157);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_instantsearch__["b" /* createFromAlgoliaCredentials */])('XJ4KFZWO2I', 'b29f97abde99f1dcd9874e03ee0807fc');
    // Videdressing : Latitude : 48.859649 | Longitude : 2.378816
    store.queryParameters = {
      aroundLatLng: '48.859649, 2.378816',
      getRankingInfo: true,
      hitsPerPage: 1000
    };

    return {
      searchStore: store
    };
  }
});

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebaseui__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebaseui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebaseui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initFirebase__ = __webpack_require__(69);

//
//
//
//
//
//






var uiConfig = {
  callbacks: {
    // Called when the user has been successfully signed in
    signInSuccess: function signInSuccess(user, credential, redirectUrl) {
      // router.push('/')
      // Do not redirect.
      return false;
    }
  },
  credentialHelper: __WEBPACK_IMPORTED_MODULE_3_firebaseui___default.a.auth.CredentialHelper.NONE,
  // Opens IDP Providers sign-in flow in a popup
  signInFlow: 'redirect',
  signInOptions: [{
    provider: __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GoogleAuthProvider.PROVIDER_ID,
    scopes: ['https://www.googleapis.com/auth/plus.login']
  }]
};
/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4__initFirebase__["a" /* ui */].start('#firebaseui-auth-container', uiConfig);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['user'])),
  watch: {
    user: function user(val) {
      if (val) {
        if (this.$router.currentRoute.query.redirect) {
          this.$router.replace(this.$router.currentRoute.query.redirect);
        } else {
          this.$router.replace('/');
        }
      }
    }
  }
});

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-menu'
});

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(155);

//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['user']))
});

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_google_autocomplete__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_google_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_google_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__initFirebase_js__ = __webpack_require__(69);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var venuesRef = __WEBPACK_IMPORTED_MODULE_3__initFirebase_js__["b" /* db */].ref('venues');

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_2_vue_google_autocomplete___default.a },
  props: {
    venue: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          pictures: [],
          description: '',
          price_level: 1,
          is_restaurant_ticket_friendly: false,
          address: '',
          _geoloc: ''
        };
      }
    }
  },
  data: function data() {
    return {
      title: this.venue['.key'] ? 'Edition form' : 'Creation form',
      priceOptions: { 1: '€', 2: '€€', 3: '€€€', 4: '€€€€' },
      cloudinary: {
        uploadPreset: 'nnbgn8se',
        apiKey: '118663883161386',
        cloudName: 'the11'
      },
      addressError: false
    };
  },
  computed: {
    clUrl: function clUrl() {
      return 'https://api.cloudinary.com/v1_1/' + this.cloudinary.cloudName + '/upload';
    }
  },
  methods: {
    onSubmit: function onSubmit(evt) {
      evt.preventDefault();

      if (!this.venue.user) {
        this.venue.user = {
          email: this.$store.getters.user.email,
          photoURL: this.$store.getters.user.photoURL,
          uid: this.$store.getters.user.uid,
          displayName: this.$store.getters.user.displayName
        };
      }

      // Weird Hack
      delete this.venue.address.administrative_area_level_2;

      if (this.venue.address.latitude && this.venue.address.longitude) {
        this.venue._geoloc = {
          lat: this.venue.address.latitude,
          lng: this.venue.address.longitude
        };
      } else {
        this.addressError = true;
        return false;
      }

      if (!this.venue['.key']) {
        venuesRef.push(this.venue);
      } else {
        var venue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.venue); // copy
        delete venue['.key']; // delete key
        venuesRef.child(this.venue['.key']).set(venue);
      }

      this.$router.push('/');
    },
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.venue.address = addressData;
    },
    getAddressPlaceHolder: function getAddressPlaceHolder() {
      if (this.venue.address === undefined || this.venue.address === '') {
        return '';
      }
      return this.venue.address.street_number + ' ' + this.venue.address.route + ', ' + this.venue.address.locality + ', ' + this.venue.address.country;
    },

    upload: function upload(files) {
      var formData = new FormData();
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(files).forEach(function (key) {
        formData.append('file', files[key]);
        formData.append('upload_preset', that.cloudinary.uploadPreset);
        formData.append('tags', 'gs-vue,gs-vue-uploaded');
        // for (var pair of formData.entries()) {
        //   console.log(pair[0] + ', ' + pair[1])
        // }
        that.$http.post(that.clUrl, formData).then(function (res) {
          if (that.venue.pictures === undefined) {
            that.venue.pictures = [];
          }
          that.venue.pictures.push(res.body);
        });
      });
    },
    removePicture: function removePicture(index) {
      this.venue.pictures.splice(index, 1);
    },
    getThumb: function getThumb(url) {
      return url.replace(/v[0-9]+/, 'w_250,h_250,c_fill');
    }
  }
});

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_carousel__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_disqus__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_disqus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_disqus__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_disqus___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDoyPRWSXuUu9WWel323GQ1UnSc-gp8zCs',
    libraries: 'places' // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['venue'],
  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_0_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_0_vue_carousel__["Slide"]
  },
  methods: {
    getThumb: function getThumb(url) {
      return url.replace(/v[0-9]+/, 'w_1200,h_800,c_fill');
    }
  },
  data: function data() {
    return {
      center: { lat: this.venue.address.latitude, lng: this.venue.address.longitude }
    };
  }
});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__initFirebase_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Preview__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Edit__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Edit__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  firebase: function firebase() {
    if (this.$route.params.key) {
      return {
        venue: {
          source: __WEBPACK_IMPORTED_MODULE_0__initFirebase_js__["b" /* db */].ref('venues/' + this.$route.params.key),
          asObject: true
        }
      };
    }
    return {};
  },

  components: {
    VenuePreview: __WEBPACK_IMPORTED_MODULE_1__Preview___default.a,
    VenueEdit: __WEBPACK_IMPORTED_MODULE_2__Edit___default.a
  }
});

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(660),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d81e8f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(477)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(662),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(664),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7bfca91c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(475)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(659),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
  __webpack_require__(470)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(655),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0426adbe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(474)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(658),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1baa77c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(653),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(654),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(661),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(663),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(665),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(657),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 653:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autocompleteText),
      expression: "autocompleteText"
    }],
    ref: "autocomplete",
    class: _vm.classname,
    attrs: {
      "type": "text",
      "id": _vm.id,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.autocompleteText)
    },
    on: {
      "focus": function($event) {
        _vm.onFocus()
      },
      "blur": function($event) {
        _vm.onBlur()
      },
      "change": _vm.onChange,
      "keypress": _vm.onKeyPress,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autocompleteText = $event.target.value
      }
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.venue.name))]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('carousel', {
    staticStyle: {
      "text-shadow": "1px 1px 2px #333"
    },
    attrs: {
      "per-page": 1,
      "paginationPadding": 4,
      "paginationSize": 6
    }
  }, _vm._l((_vm.venue.pictures), function(picture) {
    return _c('slide', {
      key: picture.signature
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": _vm.getThumb(picture.url)
      }
    })])
  }))], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [(_vm.venue.is_restaurant_ticket_friendly) ? _c('p', [_c('strong', [_vm._v("TR")]), _vm._v(" "), _c('sup', [_vm._v("friendly")])]) : _c('p', [_c('strong', [_vm._v("TR")]), _vm._v(" "), _c('sup', [_c('u', [_vm._v("NOT")]), _vm._v(" friendly")])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.venue.description))]), _vm._v(" "), _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 16
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.center,
      "clickable": false,
      "draggable": false
    }
  })], 1), _vm._v(" "), (_vm.venue.address) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.venue.address.street_number) + "\n        " + _vm._s(_vm.venue.address.route) + ",\n        " + _vm._s(_vm.venue.address.postal_code) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.venue.user) ? _c('p', [_c('strong', [_vm._v("Recommended by:")]), _vm._v(" "), _c('b-img', {
    attrs: {
      "src": _vm.venue.user.photoURL,
      "rounded": "circle",
      "width": "25px",
      "height": "25px"
    }
  }), _vm._v("\n        " + _vm._s(_vm.venue.user.displayName) + "\n      ")], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "comments"
  }, [_c('vue-disqus', {
    attrs: {
      "shortname": "le11eme",
      "identifier": _vm.venue['.key']
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('h5', [_vm._v("Venue name:")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "mb-3",
    attrs: {
      "id": "venue-name",
      "type": "text",
      "required": "",
      "placeholder": "Venue Name"
    },
    model: {
      value: (_vm.venue.name),
      callback: function($$v) {
        _vm.$set(_vm.venue, "name", $$v)
      },
      expression: "venue.name"
    }
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h5', [_vm._v("Venue price level:")]), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.priceOptions
    },
    model: {
      value: (_vm.venue.price_level),
      callback: function($$v) {
        _vm.$set(_vm.venue, "price_level", $$v)
      },
      expression: "venue.price_level"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h5', [_vm._v("Ticket Restaurant Friendly?")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.venue.is_restaurant_ticket_friendly),
      callback: function($$v) {
        _vm.$set(_vm.venue, "is_restaurant_ticket_friendly", $$v)
      },
      expression: "venue.is_restaurant_ticket_friendly"
    }
  })], 1)], 1), _vm._v(" "), _c('h5', [_vm._v("Description:")]), _vm._v(" "), _c('b-form-textarea', {
    staticClass: "mb-3",
    attrs: {
      "placeholder": "Venue description",
      "rows": 5,
      "max-rows": 6
    },
    model: {
      value: (_vm.venue.description),
      callback: function($$v) {
        _vm.$set(_vm.venue, "description", $$v)
      },
      expression: "venue.description"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Address:")]), _vm._v(" "), _c('vue-google-autocomplete', {
    ref: "address",
    staticClass: "mb-3",
    attrs: {
      "id": "map",
      "classname": "form-control",
      "placeholder": "Please type your address",
      "value": _vm.getAddressPlaceHolder(),
      "country": "fr",
      "required": ""
    },
    on: {
      "placechanged": _vm.getAddressData
    }
  }), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "show": _vm.addressError,
      "target": "map",
      "placement": "top"
    },
    on: {
      "update:show": function($event) {
        _vm.addressError = $event
      }
    }
  }, [_vm._v("\n      Please start writing an address\n    ")]), _vm._v(" "), _c('h5', [_vm._v("Pictures:")]), _vm._v(" "), _c('b-form-file', {
    staticClass: "form-control mb-3",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.upload($event.target.files)
      }
    }
  }), _vm._v(" "), _c('b-container', {
    staticClass: "p-4 bg-dark mb-3",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "mb-2 text-center"
  }, _vm._l((_vm.venue.pictures), function(picture) {
    return _c('b-col', {
      key: picture.signature
    }, [_c('b-img', {
      attrs: {
        "thumbnail": "",
        "fluid": "",
        "src": _vm.getThumb(picture.url),
        "alt": "Thumbnail"
      }
    })], 1)
  })), _vm._v(" "), _c('b-row', {
    staticClass: "text-center"
  }, _vm._l((_vm.venue.pictures), function(picture, index) {
    return _c('b-col', {
      key: picture.signature
    }, [_c('b-button', {
      attrs: {
        "variant": "warning",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removePicture(index)
        }
      }
    }, [_vm._v("Remove")])], 1)
  }))], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "size": "lg"
    }
  }, [_vm._v("Ok")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 657:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 658:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.venue['.key']) ? _c('div', {
    staticClass: "col-12 venue"
  }, [(_vm.$store.getters.user !== null) ? _c('b-button-toolbar', {
    staticClass: "float-right",
    attrs: {
      "aria-label": "Toolbar",
      "is-nav-bar": ""
    }
  }, [_c('b-button-group', [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.editionForm",
      modifiers: {
        "editionForm": true
      }
    }],
    staticClass: "m-1"
  }, [_vm._v("Edit Venue")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "editionForm"
    }
  }, [_c('venue-edit', {
    staticClass: "border border-top-0 border-right-0 border-left-0 mb-3 pb-3",
    attrs: {
      "venue": _vm.venue
    }
  })], 1), _vm._v(" "), _c('venue-preview', {
    attrs: {
      "venue": _vm.venue
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 659:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user) ? _c('b-col', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-fluid profilePic mb-3",
    attrs: {
      "src": _vm.user.photoURL
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.email))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', [_c('b-row', [_c('b-col', [_c('ais-search-box', {
    staticClass: "mb-3",
    attrs: {
      "search-store": _vm.searchStore
    }
  }, [_c('ais-input', {
    attrs: {
      "search-store": _vm.searchStore,
      "placeholder": "Search for venue",
      "class-names": {
        'ais-input': 'form-control'
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('ais-index', {
    attrs: {
      "search-store": _vm.searchStore,
      "index-name": "venues"
    }
  }, [_c('ais-results', {
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('b-row', _vm._l((_vm.results), function(result) {
            return _c('b-col', {
              key: result.objectID,
              attrs: {
                "cols": "12",
                "md": "6",
                "lg": "4"
              }
            }, [_c('router-link', {
              attrs: {
                "to": {
                  name: 'VenueView',
                  params: {
                    key: result.objectID
                  }
                }
              }
            }, [_c('div', {
              staticClass: "text-center mb-3 card text-white"
            }, [_c('img', {
              staticClass: "card-img",
              attrs: {
                "src": result.pictures[0].secure_url.replace(/v[0-9]+/, 'w_288,h_192,c_fill'),
                "srcset": result.pictures[0].secure_url.replace(/v[0-9]+/, 'w_288,h_192,c_fill') + ' 320w,' +
                  result.pictures[0].secure_url.replace(/v[0-9]+/, 'w_576,h_384,c_fill') + ' 640w,' +
                  result.pictures[0].secure_url.replace(/v[0-9]+/, 'w_462,h_308,c_fill') + ' 992w,' +
                  result.pictures[0].secure_url.replace(/v[0-9]+/, 'w_312,h_208,c_fill') + ' 1024w',
                "alt": result.name
              }
            }), _vm._v(" "), _c('div', {
              staticClass: "card-body card-img-overlay"
            }, [_c('h4', {
              staticClass: "card-title"
            }, [_vm._v(_vm._s(result.name))]), _vm._v(" "), (!result._rankingInfo.promoted) ? _c('span', [_vm._v("\n                    <" + _vm._s(Math.ceil(result._rankingInfo.geoDistance / 100) * 100) + "m\n                  ")]) : _vm._e()])])])], 1)
          }))
        
      },
      staticRenderFns: []
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', [_c('h1', [_vm._v("Login")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "firebaseui-auth-container"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    attrs: {
      "toggleable": "md",
      "fixed": "top",
      "type": "light",
      "variant": "light"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'Hello'
      }
    }
  }, [_c('span', [_vm._v("Le11e.me")])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [(_vm.$store.getters.user === null) ? _c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Sign in")])], 1) : _c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'Logout'
      }
    }
  }, [_vm._v("Logout")])], 1), _vm._v(" "), (_vm.$store.getters.user !== null) ? _c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'Profile'
      }
    }
  }, [_vm._v("Profile")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.user !== null) ? _c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'VenueAdd'
      }
    }
  }, [_vm._v("Add Venue")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main-menu', {
    key: _vm.$route.fullPath
  }), _vm._v(" "), _c('b-container', [_c('transition', {
    attrs: {
      "name": _vm.transitionName(),
      "mode": "out-in"
    }
  }, [_c('div', {
    key: _vm.$route.fullPath
  }, [_c('b-row', [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('footer', [_c('p', [_vm._v("© Videdressing 2017 - " + _vm._s(_vm.currentYear))]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://github.com/videdressing/the_11"
    }
  }, [_vm._v("Docs")])])])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ui; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebaseui__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebaseui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebaseui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebaseui_dist_firebaseui_css__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebaseui_dist_firebaseui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebaseui_dist_firebaseui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(100);





var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
  apiKey: 'AIzaSyCramd7M5btluFH6cvt25AMjOthN_roP2U',
  authDomain: 'the-11.firebaseapp.com',
  databaseURL: 'https://the-11.firebaseio.com',
  projectId: 'the-11',
  storageBucket: 'the-11.appspot.com',
  messagingSenderId: '442759699979'
});

// if (__DEV__) {
//   window.firebase = firebase
// }

var ui = new __WEBPACK_IMPORTED_MODULE_1_firebaseui___default.a.auth.AuthUI(__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth());
var db = firebaseApp.database();

/**
 * Sync store.state.user with firebase.auth().currentUser
 *
 * This callback is called when firebase.auth() detects user changes,
 * so just update the vuex store with the new user object.
 */
__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('UPDATE_USER', user);
});

/***/ })

},[311]);


// WEBPACK FOOTER //
// static/js/app.1676c809e25b5528da8a.js